enum UIProviderEnum {
  ReactBootstrap,
  ReactOverlays,
  Custom,
  ReactBootstrapCopy,
}

export default UIProviderEnum;
